import { InternalCommunicationLog } from "../../../models/InternalCommunicationLog";

export class AddInternalCommunicationInput {
    internalCommunicationLog: InternalCommunicationLog;

    constructor() {
        this.internalCommunicationLog = new InternalCommunicationLog();
    }
}